import { useAutoAnimate } from "@formkit/auto-animate/react"
import { useContext, useState } from "react"
import { Context } from "../../store/store"
import Popup from "../elements/Popup"
import ReceiptUpload from "./ReceiptUpload"
import { getText } from "../strapi"

const Receipt = () => {
	const { globalState } = useContext(Context)
	const [showSample, setShowSample] = useState<boolean>(false)
	const [animationRef] = useAutoAnimate<HTMLDivElement>()

	return (
		<section className="js-mitmachen  relative pb-12 sm:pb-24 pt-12 md:pt-[0]  ">
			<div className="container mx-auto text-center">
				{/*<h2 className="mb-1 text-blue">{getText(globalState.strapi.homepage.receiptHeadline, "receiptHeadline")}</h2>*/}
				{/*<p className="copy pb-7 sm:pb-10 text-white font-AndesBold text-[21px] pt-2 leading-tight ">{getText(globalState.strapi.homepage.receiptCopy, "receiptCopy")}</p>*/}
				<div className="p-1 px-0 md:px-0">
					<div className="arrow-white mx-auto max-w-[1324px] rounded-lg border-[2px] border-dashed border-blue bg-white px-4 pt-16 pb-32 sm:pt-32 sm:pb-16 bg-[url('/src/bgimages/receipt-upload-bg-mobile.png')] md:bg-[url('/src/bgimages/receipt-upload-bg.png')] bg-cover bg-right md:bg-left md:bg-contain bg-no-repeat">
								
						<ReceiptUpload />
					</div>
				</div>
				<div>
					<p className="mx-auto mt-5 sm:mt-1 max-w-[600px] text-center font-AmsiRegular text-blue underline text-[14px] sm:text-[17px]">
						<span className="cursor-pointer underline" onClick={() => setShowSample(true)}>
							{getText(globalState.strapi.homepage.receiptSample, "receiptSample")}
						</span>
					</p>
				</div>
			</div>
			<div ref={animationRef}>
				{showSample && (
					<Popup close={() => setShowSample(false)}>
						<img src={process.env.PUBLIC_URL + "/images/kassenbon-beispiel-mobile.jpg"} alt="Kassenbon Beispiel" className="mx-auto block max-h-[80vh] w-auto lg:hidden" />
						<img src={process.env.PUBLIC_URL + "/images/kassenbon-beispiel.jpg"} alt="Kassenbon Beispiel" className="mx-auto hidden max-h-[80vh] w-auto lg:block" />
					</Popup>
				)}
			</div>
			
		</section>
	)
}

export default Receipt
